module.exports = __webpack_public_path__ + "img/37.69f127c3.jpg";